import { render, staticRenderFns } from "./top-picture.vue?vue&type=template&id=001ac2a3&scoped=true"
import script from "./top-picture.vue?vue&type=script&lang=js"
export * from "./top-picture.vue?vue&type=script&lang=js"
import style0 from "./top-picture.vue?vue&type=style&index=0&id=001ac2a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ac2a3",
  null
  
)

export default component.exports